import { render, staticRenderFns } from "./als-wann-wenn.vue?vue&type=template&id=e668d648&scoped=true"
import script from "./als-wann-wenn.vue?vue&type=script&lang=js"
export * from "./als-wann-wenn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e668d648",
  null
  
)

export default component.exports